/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, once the page has loaded. It runs entirely in your browser using the device clock, with no server calls needed to keep counting, so it keeps working if your connection drops.`)
};

const es_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, una vez que la página se ha cargado. Se ejecuta completamente en tu navegador usando el reloj del dispositivo, sin necesitar llamadas al servidor para seguir contando, así que sigue funcionando si se corta tu conexión.`)
};

const de_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, sobald die Seite geladen ist. Sie läuft komplett im Browser über die Geräteuhr, ohne Serveraufrufe zum Weiterzählen, und funktioniert daher auch bei Verbindungsabbruch weiter.`)
};

const nl_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, zodra de pagina is geladen. Hij draait volledig in je browser met de klok van je apparaat, zonder servercalls om te blijven tellen, dus hij blijft werken als je verbinding wegvalt.`)
};

const fr_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, une fois la page chargée. Il fonctionne entièrement dans votre navigateur en utilisant l’horloge de l’appareil, sans aucun appel serveur nécessaire pour continuer à compter, donc il continue de fonctionner si votre connexion coupe.`)
};

const it_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, una volta caricata la pagina. Funziona interamente nel browser utilizzando l'orologio del dispositivo, senza bisogno di chiamate al server per continuare a contare, quindi continua a funzionare anche se la connessione si interrompe.`)
};

const pt_br2_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, depois que a página é carregada. Ele roda inteiramente no seu navegador usando o relógio do dispositivo, sem precisar de chamadas ao servidor para continuar contando, então continua funcionando mesmo se sua conexão cair.`)
};

const pt_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, depois de a página ter carregado. Funciona inteiramente no seu navegador, usando o relógio do dispositivo, sem necessidade de chamadas ao servidor para continuar a contar, por isso continua a funcionar mesmo que a ligação falhe.`)
};

const ja_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、ページを読み込んだ後であれば使えます。デバイスの時計を使ってブラウザ上で完全に動作し、計測を続けるのにサーバー通信を必要としないため、接続が切れても動き続けます。`)
};

const zh_timer_stopwatch_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以，只要页面已加载完成。秒表完全在浏览器中运行，使用设备时钟计时，无需服务器调用即可持续计时，因此断网也不影响使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq3_a", locale)
	if (locale === "en") return en_timer_stopwatch_faq3_a(inputs)
	if (locale === "es") return es_timer_stopwatch_faq3_a(inputs)
	if (locale === "de") return de_timer_stopwatch_faq3_a(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq3_a(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq3_a(inputs)
	if (locale === "it") return it_timer_stopwatch_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq3_a(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq3_a(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq3_a(inputs)
	return zh_timer_stopwatch_faq3_a(inputs)
};